import useFirebase from "../../useFirebase";

function useBatteryPercentage(setBatteryPercentage) {
  const { getDeviceStatus } = useFirebase();

  function getBatteryPercentageData(deviceId) {
    async function getDeviceStatusMethod(deviceId) {
      const deviceStatusValue = await getDeviceStatus(deviceId);
      setBatteryPercentage(deviceStatusValue?.data?.batteryPercentage);
    }

    if (deviceId) getDeviceStatusMethod(deviceId);
    else return;
  }

  return {
    getBatteryPercentageData
  };
}

export default useBatteryPercentage;
